/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetLoanBalances = (loanNumber, date) => {
  const { get } = useAbortController();
  const { token } = useAuthContext();

  const [loanBalancesInfo, setLoanBalancesInfo] = useState({
    suspenseBal: 0,
    assessmentBal: 0,
    corpAdvBal: 0,
    lcAcrdBal: 0,
  });
  const [loanBalancesStatus, setLoanBalancesStatus] = useState('done');

  const getLoanBalancesInfo = useCallback(async () => {
    if (!token || !loanNumber || !date) return;
    const controller = get();
    const config = { signal: controller.signal };
    const headers = {
      'Session-Token': token,
    };

    try {
      setLoanBalancesStatus('loading');
      let response = await axiosCall(
        { url: `live/loan/${loanNumber}/payment/balance/${date}`, method: 'get' },
        config,
        headers,
      );
      setLoanBalancesInfo(response);
      setLoanBalancesStatus('done');
    } catch (e) {
      if (e.code !== 'ERR_CANCELED') {
        console.error('Unable to load loan info: ' + e);
        setLoanBalancesStatus('error');
      }
    }
  }, [get, loanNumber, date, token]);

  useEffect(() => {
    getLoanBalancesInfo();
  }, [getLoanBalancesInfo]);

  return {
    loanBalancesInfo,
    loanBalancesStatus,
  };
};

export default useGetLoanBalances;
